<template>
  <form v-if="team">
    <div
      class="modal-card"
      style="width: auto">
      <header class="modal-card-head">
        <p
          class="modal-card-title">
          <translate>Radera Lag</translate> &nbsp; {{ team.name }}
        </p>
      </header>
      <section
        class="modal-card-body">
        <p>
          <translate>Detta raderar lagets alla resultat!</translate>
        </p>
      </section>
      <footer class="modal-card-foot">
        <button
          class="button is-danger"
          @click="save">
          <translate>Radera</translate>
        </button>
      </footer>
    </div>
  </form>
</template>


<script>
import { teamService } from '../../_services';

export default {
  name: 'DeleteTeam',
  props: {id: {type: Number, default: null}},
  data() {
    return {
      team: undefined,
    }
  },
  async created() {
    var self = this
    try{
      self.team = await teamService.get(self.id)
    }catch(err){
      console.error('Caught error')
      console.error(err)
    }
  },
  methods: {
    save: async function(){
      await teamService.remove(this.id)
    }
  },
}
</script>
